module.exports = __webpack_public_path__ + "507d00a48b5693c4845a197a766f6af3.gif";